import { isSSR } from 'uix/utils';
import log from 'uix/logging';
import { dict, keys, range, items } from 'ldash';
export const readCurrentCssVars = ()=>{
    /* read css vars from loaded document
   */ return Array.from(document.styleSheets).filter((styleSheet)=>{
        try {
            return styleSheet.cssRules;
        } catch (e) {
            console.warn(e);
        }
    }).map((styleSheet)=>Array.from(styleSheet.cssRules)).flat().filter((cssRule)=>cssRule.selectorText === ':root').map((cssRule)=>Array.from(cssRule.style).filter((name)=>name.startsWith('--')).map((name)=>({
                key: name.trim(),
                value: cssRule.style.getPropertyValue(name).trim()
            }))).flat();
};
// collapse into dict form
export const readCurrentCssVarDict = ()=>dict(readCurrentCssVars().map(({ key, value })=>[
            key,
            value
        ]));
const CSS_VARS = isSSR ? {} : readCurrentCssVarDict();
export const CSS_VAR_NAMES = keys(CSS_VARS);
import { THEMES } from './themes';
const MAX_RESOLVE_LEVEL = 10;
const resolveCSSVars = (data)=>{
    /* resolve values of css vars with transitive dependencies
   */ data = {
        ...CSS_VARS,
        ...data
    };
    for (let i of range(MAX_RESOLVE_LEVEL)){
        let unresolved = false;
        data = dict(items(data).map(([name, value])=>{
            let derived = value.replace(/var\((--.*)\)/, (a, b)=>{
                if (!data[b]) {
                    console.warn('invalid var ref', b);
                    return '';
                }
                return data[b];
            });
            if (derived.startsWith('var(')) {
                unresolved = true;
            }
            //~ console.log(value, derived)
            return [
                name,
                derived
            ];
        }));
        if (!unresolved) {
            break;
        }
    }
    return data;
};
const DARK_MODE = isSSR ? false : window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
export const DEFAULT_THEME = DARK_MODE ? 'dark' : 'default';
const DEFAULT_CHANGED = new Set();
export const applyTheme = (theme)=>{
    theme = theme || DEFAULT_THEME;
    if (!isSSR) {
        for (let name of DEFAULT_CHANGED){
            document.documentElement.style.removeProperty(name, CSS_VARS[name]);
        }
        if (THEMES[theme]) {
            for (let [name, value] of items(THEMES[theme])){
                DEFAULT_CHANGED.add(name);
                document.documentElement.style.setProperty(name, value);
            }
        } else if (theme !== 'default') {
            log.warn('unknown theme %o', theme);
        }
    }
};
export const registerCSSVariables = ()=>{
    /* https://developers.google.com/web/updates/2019/10/nic78#css-prop-val
  CSS only: https://www.w3.org/TR/css-properties-values-api-1/#at-ruledef-property
  */ if (isSSR) return;
    if (!window.CSS || !window.CSS.registerProperty) {
        log.warn('CSS variable registration not supported');
        return;
    }
    return;
    window.CSS.registerProperty({
        name: '--vl_body_color',
        syntax: '<color>',
        inherits: true,
        initialValue: '#444'
    });
};
